module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/funabashi_ekimae_point3_2-abeadc431ae952f79f847b79a2d72f5f.jpg";